import * as React from "react";
const IconAngleDoubleLeftCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M28.6 32 50.5 9.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-22.6 23c-.4.4-.4 1 0 1.4l22.6 23c.2.2.5.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4z" />
    <path d="M15.6 32 37.5 9.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-22.6 23c-.4.4-.4 1 0 1.4l22.6 23c.2.2.5.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4z" />
  </svg>
);
export default IconAngleDoubleLeftCopy;
